import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ScrollToTop } from "@/components/Bits";

import Home from "@/pages/Home";
import Vision from "@/pages/Vision";
import LearningRedefined from "@/pages/LearningRedefined";
import Stem from "@/pages/Stem";
import Framework from "@/pages/Framework";
import ConceptLabs from "@/pages/ConceptLabs";
import Research from "@/pages/Research";
import OurPartners from "@/pages/OurPartners";
import KeyFeatures from "@/pages/KeyFeatures";
import NTP from "@/pages/NTP";
import Outcomes from "@/pages/Outcomes";
import Enroll from "@/pages/Enroll";
import WhyPblTdle from "@/pages/WhyPblTdle";
import YourJourney from "@/pages/YourJourney";
import TheCreator from "@/pages/TheCreator";
import Tutor from "@/pages/Tutor";
import Contact from "@/pages/Contact";
import About from "@/pages/About";

function App() {
  return (
    <div className="App bg-[#050B14]">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/learning-redefined" element={<LearningRedefined />} />
              <Route path="/stem" element={<Stem />} />
              <Route path="/framework" element={<Framework />} />
              <Route path="/concept-labs" element={<ConceptLabs />} />
              <Route path="/key-features" element={<KeyFeatures />} />
              <Route path="/ntp" element={<NTP />} />
              <Route path="/research" element={<Research />} />
              <Route path="/outcomes" element={<Outcomes />} />
              <Route path="/enroll" element={<Enroll />} />
              <Route path="/why-pbl-tdle" element={<WhyPblTdle />} />
              <Route path="/your-journey" element={<YourJourney />} />
              <Route path="/thecreator" element={<TheCreator />} />
              <Route path="/our-partners" element={<OurPartners />} />
              <Route path="/become-a-tutor" element={<Tutor />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F172A",
            color: "#F5F4EE",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
